import {
  DiscoverSearchSplitData,
  DiscoverSearchSplitVariant,
  UseDiscoverSearchSplit,
} from "./types";
import { useMonarchRule } from "../MonarchRulesProvider";

const CUSTOM_RULE_ID = "discoverSearchSplit";

const defaultData: DiscoverSearchSplitData = {
  enableTest: false,
};

const useDiscoverSearchSplit: UseDiscoverSearchSplit = (): {
  isLoading: boolean;
  variant: DiscoverSearchSplitVariant;
  data: DiscoverSearchSplitData;
} => {
  const { isLoading, value } = useMonarchRule<DiscoverSearchSplitData>(
    CUSTOM_RULE_ID,
    {},
  );

  if (isLoading) {
    return {
      isLoading,
      variant: "control",
      data: defaultData,
    };
  }

  const data = value ?? defaultData;
  const variant: DiscoverSearchSplitVariant = data.enableTest
    ? "authx"
    : "control";

  return {
    isLoading,
    variant,
    data,
  };
};

export default useDiscoverSearchSplit;
